
/* eslint-disable */
import firebase from 'firebase/compat/app'
export default {
  name: 'CreateReferee',
  props: ['title'],
  data: () => ({
    dialog: false,
    snackbar: {
      visible: false,
      text: 'Referee created'
    },
    referee: {
      name: '',
      gender: 'male',
      mobile: '',
      birthday: null as any
    },
    activePicker: null,
    date: null as any
  }),
  mounted () {
    this.$store.dispatch('SettingsModule/fetchAndAdd')
  },
  watch: {
    menu (val) {
      val && setTimeout(() => ((this.$refs.picker as any).activePicker) = 'YEAR')
    }
  },
  methods: {
    setDate (date: Date) {
      (this.$refs.dialog as any).save(date)
    },
    save () {
      this.referee.birthday = firebase.firestore.Timestamp.fromDate(new Date(this.date))

      this.$store.dispatch('RefereesModule/insert', this.referee).then(id => {
        this.snackbar.visible = true
        var self = this

        Object.keys(this.referee).forEach(function(key,index) {
          self.referee[key] = ''
        })
      }).catch(error => {
        console.log('Error', error)
      })
    }
  }
}
